<template>
	<page>
		<module v-if="!auth('b_home_work')" enable-flex>
			<div class="empty flex-grow flex-center">
				<img src="@/assets/image/home.png" alt="">
			</div>
		</module>
		<module v-else :drag="false" gap="12">
			<module-row size="auto" title="工序任务">
				<template #head>
					<div class="module-head flex-between-center">
						<div class="flex">
							<c-link class="flex-center" color="main" @click="processConfig()"><i class="tf">&#xe671;</i></c-link>
							<c-refresh class="flex-center" color="main" @click="updateProcess()"></c-refresh>
						</div>
						<div class="flex-center head-handle">
							<c-checkbox v-model="unstartProcess">含未开始的生产任务</c-checkbox>
							<c-tab-list :tabs="timeTab" type="card" @change="updateProcess"></c-tab-list>
						</div>
					</div>
				</template>

				<c-empty v-if="!processList.length"></c-empty>
				<div v-else class="process-list" :style="{'height': processFold ? '120px' : 'auto', 'margin-bottom': moreProcess ? '40px' : '20px'}">
					<ul ref="processList" class="flex-wrap">
						<li v-for="(item, i) in processList" :key="i" class="flex-column">
							<label>{{item.process_name}}</label>
							<div class="flex-grow flex-center">
								<div class="count flex-grow flex-center flex-column">
									<div :style="{'color': item.task_count > 0 ? '#000' : '#999'}">{{item.task_count}}</div>
									<p>生产任务数</p>
								</div>
								<div class="info">
									<p>计划数：<span style="color: #000;">{{item.plan_count}}</span></p>
									<p>良品数：<span style="color: #00B38A;">{{item.fine_count}}</span></p>
									<p>不良品：<span style="color: #FF0000;">{{item.defects_count}}</span></p>
								</div>
							</div>
							<div class="rate flex-center-cross">
								<p>进度</p>
								<div class="flex-grow">
									<c-progress v-if="item.plan_count > 0" :rate="[item.fine_count, item.plan_count]" :color="((item.fine_count/item.plan_count)>=1||item.plan_count==0) ?'green':'blue'"></c-progress>
									<span v-else>-</span>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<a v-if="moreProcess" class="process-more flex-center" @click="processFold = !processFold">
					<i class="tf" :style="{'transform': `rotate(${processFold ? '0' : '180deg'})`}">&#xe61c;</i>
				</a>
			</module-row>

			<module-row size="auto">
				<module-col title="绩效统计">
					<template #head>
						<div class="module-head flex-end-center">
							<div class="flex-center head-handle">
								<c-tab-list :tabs="timeTab" type="card" @change="updatePerformance"></c-tab-list>
							</div>
						</div>
					</template>

					<ul class="performance-list flex-wrap">
						<li v-for="(item, i) in performanceList" :key="i" class="flex-column flex-center">
							<div class="data" :style="{'color': item.color}">
								{{item.value}}<span>{{item.unit || ''}}</span>
							</div>
							<div class="flex-center">
								<p>{{item.name}}</p>
								<c-tooltip v-if="item.tip" :tip="item.tip" width="150" position="top"></c-tooltip>
							</div>
						</li>
					</ul>
				</module-col>
				
				<module-col size="33%" title="不良品分布情况">
					<template #head>
						<div class="module-head flex-end-center">
							<div class="flex-center head-handle">
								<c-tab-list :tabs="timeTab" type="card" @change="updateDefects"></c-tab-list>
							</div>
						</div>
					</template>
					<pie ref="pie"></pie>
				</module-col>
			</module-row>

			<module-row title="生产管理流程" size="auto">
				<flow-produce @route="routeHandle"></flow-produce>
			</module-row>
			
			<module-row size="auto" title="工单进度报表">
				<template #head>
					<div class="module-head flex-end-center">
						<div class="flex-center head-handle">
							<c-tab-list :tabs="workTab" type="card" @change="updateWork"></c-tab-list>
							<c-button prepend-icon="tf-field-config" @click="globalDialog('fieldConfig', {props: {viewId: 10010}}, updateWorkField)">字段配置</c-button>
						</div>
					</div>
				</template>
				<c-table ref="workList" height="505" width-resize :paging="{size: 5, select: false}" @widthResize="widthResizeHandle">
					<template v-for="(col, i) in workField">
						<c-table-column
							v-if="col.is_display == 1"
							:key="col.field_code"
							:label="col.field_title"
							:name="col.field_code"
							:width="col.width"
							:fixed="col.is_lock == 1 ? 'left' : false"
						>
							<!--产品来源-->
							<template v-if="col.field_code == 'product_source'" #default="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
						
							<!--产品类型-->
							<template v-if="col.field_code == 'product_type'" #default="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--工单进度-->
							<template v-else-if="col.field_code == 'process_rate'" #default="{data}">
								<process-rate :key="data._timestamp" :id="data.id" @output="$refs.workList.refresh()"></process-rate>
							</template>
							
							<!--工单进度%-->
							<template v-else-if="col.field_code == 'work_progress'" #default="{data}">
								<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--工单明细进度%-->
							<template v-else-if="col.field_code == 'work_detail_progress'" #default="{data}">
								<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--工单状态-->
							<template v-else-if="col.field_code == 'work_state'" #default="{data}">
								<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
							</template>
							
							<!--优先级-->
							<template v-else-if="col.field_code == 'priority'" #default="{data}">
								<c-state dict="priorityDic" tag :value="data.priority"></c-state>
							</template>
							
							<!--关联单据-->
							<template v-else-if="col.field_code == 'ref_code'" #default="{data}">
								<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
							</template>

							<template v-else #default="{data}">
								{{data[col.field_code]}}
							</template>
						</c-table-column>
					</template>

					<c-table-column
						type="button"
						label="操作"
						width="125"
						:width-resize="false"
					>
						<template #default="{data}">
							<c-table-button v-if="auth('b_work_start')" v-lock="lock('b_work_start')" :disabled="!(data.work_state == 1)" icon="tf-start" @click="editWorkState(data, 2)">开始</c-table-button>
							<c-table-button v-if="auth('b_work_finish')" v-lock="lock('b_work_finish')" :disabled="!((data.work_state == 1 || data.work_state == 2))" icon="tf-end" @click="editWorkState(data, 3)">结束</c-table-button>
							<c-table-button v-if="auth('b_work_withdraw')" v-lock="lock('b_work_withdraw')" :disabled="!(data.work_state != 1)" icon="tf-recall" @click="editWorkState(data, -1)">撤回</c-table-button>
							<c-table-button v-if="auth('b_work_cancel')" v-lock="lock('b_work_cancel')" :disabled="!(data.work_state != 4)" icon="tf-cancel" @click="editWorkState(data, 4)">取消</c-table-button>
							<c-table-button v-if="auth('b_work_delete')" v-lock="lock('b_work_delete')" icon="tf-trash" color="red" @click="deleteWork(data)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</module-row>
		</module>
	</page>
</template>

<script>
	import pie from './components/pie.vue'
	import flowProduce from './components/flow_produce.vue'
	import flowStorage from './components/flow_storage.vue'

	export default {
		name: 'home',

		components: {
			pie,
			flowProduce,
			flowStorage
		},

		props: {
			type: String
		},

		data() {
			return {
				unstartProcess: false,
				timeTab: [],
				currentProcessTab: {},
				processList: [],
				moreProcess: false,
				processFold: true,

				performanceList: [],

				workTab: [],
				workField: []
			}
		},

		watch: {
			unstartProcess() {
				this.updateProcess();
			}
		},

		mounted() {
			this.request({
				url: '/time/type',
				data: {
					type: 2
				},
				success: data => {
					this.timeTab = data.map(item => {
						return {
							name: item.name,
							value: item.time_type
						}
					});
				}
			});

			this.request({
				url: '/home/work/filter',
				success: data => {
					this.workTab = data.map(item => {
						return {
							name: item.name,
							value: item.type
						}
					});
				}
			});

			this.updateWorkField();

			window.addEventListener('resize', this.resize);
		},

		beforeDestroy() {
			window.removeEventListener('resize', this.resize);
		},

		methods: {
			//配置工序
			processConfig(){
				this.globalDialog('processConfig',{
					props: {
						type: 1
					}
				}, this.updateProcess);
			},

			updateProcess(tab = this.currentProcessTab) {
				this.currentProcessTab = tab;
				this.request({
					url: '/home/process',
					data: {
						include_not_start_task: this.unstartProcess ? 1 : 0,
						time_type: tab.value
					},
					success: data => {
						this.processList = data;
						this.resize();
					}
				})
			},

			updatePerformance(tab) {
				this.request({
					url: '/home/summary',
					data: {
						time_type: tab.value
					},
					success: data => {
						this.performanceList = [{
							name: '工单计划数量',
							code: 'plan_count'
						}, {
							name: '工单完成数量',
							code: 'completed_count',
							color: '#00B38A'
						}, {
							name: '工单数',
							code: 'work_count'
						}, {
							name: '不良品率',
							code: 'defective_rate',
							color: '#FF8A00',
							unit: '%',
							tip:'不良品率 = 不良品数 ÷ 报工总数 （仅计算最后一道工序）'
						}, {
							name: '平均工单生产周期',
							code: 'avg_duration',
							unit: '天'
						}, {
							name: '超期未完成工单',
							code: 'overdue_work_count',
							color: '#FF414A'
						}].map(item => {
							item.value = data[item.code] || 0;
							return item;
						});
					}
				});
			},

			updateDefects(tab) {
				this.request({
					url: '/home/defects/distribution',
					data: {
						time_type: tab.value
					},
					success: data => {
						this.$refs.pie && this.$refs.pie.update(data.map(item => {
							return {
								name: item.defects_name,
								value: item.count
							}
						}));
					}
				});
			},

			updateWorkField() {
				this.request({
					url: '/sys_user_view/config',
					data: {
						view_id: 10010
					},
					success: data => {
						this.workField = [];
						this.$nextTick(() => {
							this.workField = data.field_list;
						});
					}
				});
			},

			updateWork(tab) {
				this.$refs.workList.load({
					url: '/home/work/list',
					data: {
						type: tab.value
					},
					success: () => {
						this.resize();
					}
				});
			},

			resize() {
				this.$nextTick(() => {
					if (this.$refs.processList) {
						this.moreProcess = this.$refs.processList.offsetHeight > 120;
					} else {
						this.moreProcess = false;
					}
					this.$refs.pie && this.$refs.pie.resize();
				});
			},

			async editWorkState(data, state){
				if(state != 4 || await this.$confirm({
					title: '确认取消工单？',
					message: `取消后，工单${data.work_code}将不允许报工，支持撤回操作`
				}) == 'resolve') {
					this.request({
						url: '/work/editState',
						data: {
							id: data.id , 
							work_state: state,
						},
						loading: true,
						success: () => {
							this.$message({
								message: '操作成功'
							});
							this.$refs.workList.update();
						}
					});
				}
			},

			deleteWork(data){
				this.$confirm({
					message: `确认删除工单【${data.work_code}】？删除后不可恢复`,
					resolve: () => {
						this.request({
							url: '/work/delete',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message:'删除成功'
								});
								this.$refs.workList.update();
							}
						});
					}
				});
			},

			widthResizeHandle(col) {
				let item = this.workField.find(item => item.field_code == col.name);
				if (item) {
					item.width = col.width;
					this.request({
						url: '/sys_user_view/edit_field',
						data: {
							view_id: 10010,
							field_list: this.workField.map(item => {
								return {
									field_id: item.field_id,
									width: item.width,
									is_display: item.is_display,
									is_lock: item.is_lock
								}
							})
						}
					})
				}
			},

			routeHandle(name) {
				if (!this.auth(name)) {
					this.$message({
						message: '暂无权限，请联系管理员'
					});
				} else {
					this.navigateTo({
						name
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .c-module-head {
		height: 56px;
		border: none;

		.c-module-title {
			line-height: 56px;
		}
	}

	>>> .c-tab-list {
		ul {
			padding: 0;

			li {
				height: 28px;
			}
		}
	}

	.empty {
		img {
			width: 575px;
		}
	}

	.module-head {
		height: 100%;
		padding: 0 20px 0 12px;

		>>> .c-link {
			box-sizing: border-box;
			width: 28px;
			height: 28px;
			border: 1px solid #ddd;
			margin-right: 6px;

			&:hover {
				border-color: var(--color-main);
				color: #fff !important;
				background: var(--color-main);
			}
		}

		.head-handle {
			gap: 12px;
		}
	}

	.process {
		&-list {
			margin: 10px 20px;
			overflow: hidden;

			ul {
				gap: 14px;
				min-height: 120px;
			}

			li {
				position: relative;
				width: calc(16.6666% - 12px);
				height: 120px;
				background: #F9F9F9;

				@media screen and (max-width: 1699px) {
					width: calc(20% - 12px);
				}

				@media screen and (max-width: 1399px) {
					width: calc(25% - 12px);
				}

				@media screen and (max-width: 1199px) {
					width: calc(33.3333% - 12px);
				}

				label {
					position: absolute;
					left: 0;
					top: 0;
					padding: 0 8px;
					line-height: 22px;
					font-size: 13px;
					color: #006FF3;
					background: #E9F4FF;
				}

				.count {
					gap: 8px;
					padding-top: 10px;
					font-size: 12px;
					color: #999;

					div {
						font-size: 30px;
					}
				}

				.info {
					width: 105px;
					line-height: 24px;
					font-size: 12px;
					color: #999;
				}

				.rate {
					height: 28px;
					border-top: 1px solid #eee;
					padding: 0 10px;

					p {
						margin-right: 6px;
						font-size: 12px;
						color: #999;
					}
				}
			}
		}

		&-more {
			position: absolute;
			left: 50%;
			bottom: 0;
			transform: translate(-50%,0);
			width: 54px;
			height: 27px;
			padding: 10px 10px 0;
			overflow: hidden;
			cursor: pointer;

			&:before {
				content: '';
				position: absolute;
				left: 10px;
				top: 10px;
				width: 54px;
				height: 54px;
				border-radius: 27px;
				background: #fff;
				box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
			}

			.tf {
				position: relative;
				font-size: 10px;
				color: var(--color-main);
			}
		}
	}

	.performance {
		&-list {
			gap: 12px;
			min-height: 120px;
			padding: 10px 20px 20px;

			li {
				position: relative;
				width: calc(25% - 9px);
				height: 100px;
				background: #F9F9F9;

				@media screen and (max-width: 1199px) {
					width: calc(33.3333% - 9px);
				}

				.data {
					margin-bottom: 10px;
					font-size: 26px;

					span {
						margin-left: 2px;
						font-size: 15px;
					}
				}

				p {
					font-size: 13px;
					color: #999;

					&:nth-last-child(2) {
						margin-right: 6px;
					}
				}
			}
		}
	}
</style>